/**
 * Strict 5-digit US ZIP code validator
 */
export const validateZip = (zip) => {
  if (!zip || typeof zip !== 'string') return false;
  return /^\d{5}$/.test(zip.trim());
};

/**
 * Format/clean ZIP code: digits only, max 5 digits
 */
export const formatZipCode = (value) => {
  if (!value && value !== 0) return '';
  return String(value).replace(/\D/g, '').slice(0, 5);
};
